export var ENTITY = "signing-package";
export var REDUCER_KEY = "SIGNING_PACKAGES_V2";
export var BASE_PATH_ENTITY = "signing-packages";
export var BASE_PATH_ENTITY_FOR_SERVERLESS = "document-packages";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
